import { DataEntry } from 'models/data';

type DataEntryValues = Record<string, { value?: number }>;

function hasValueProperty(field: unknown): field is { value?: number } {
  return (
    typeof field === 'object' && field !== null && 'value' in field && (field as { value?: number }).value !== undefined
  );
}

export function areAllFieldsZero(item: DataEntry | DataEntryValues): boolean {
  return Object.values(item).every(field => {
    if (hasValueProperty(field)) {
      return field.value === 0;
    }
    return true;
  });
}

export function areAllValuesZero(values: Record<string, number>): boolean {
  return Object.values(values).every(value => value === 0);
}
